module.exports = __webpack_public_path__ + "img/3_1.b522077d.png";